"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapCells = exports.countOffsets = exports.countCellsSizes = exports.countDivisions = exports.countCells = exports.validateChild = void 0;

var _react = require("react");

var _Cell = _interopRequireDefault(require("../Cell"));

var _reduceBreakpoints = require("./reduce-breakpoints");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var checkCellType = function checkCellType(cell) {
  return typeof cell !== 'boolean' && typeof cell !== 'undefined' && cell !== null && cell !== '';
};

var filterChildren = function filterChildren(children) {
  return _react.Children.toArray(children).filter(function (child) {
    return !validateChild(child);
  });
};

var countCellTotalSize = function countCellTotalSize(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 1 : _ref$size,
      offset = _ref.offset;
  return size + ((offset === null || offset === void 0 ? void 0 : offset.before) || 0) + ((offset === null || offset === void 0 ? void 0 : offset.after) || 0);
};

var validateChild = function validateChild(child) {
  var _child$type, _child$type2, _child$type2$target, _donor$type;

  var donor = (0, _react.createElement)(_Cell["default"], {
    children: ''
  });
  return ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name) || (child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : (_child$type2$target = _child$type2.target) === null || _child$type2$target === void 0 ? void 0 : _child$type2$target.name)) !== (donor === null || donor === void 0 ? void 0 : (_donor$type = donor.type) === null || _donor$type === void 0 ? void 0 : _donor$type.name) && checkCellType(child);
};

exports.validateChild = validateChild;

var countCells = function countCells(cells) {
  return _react.Children.count(filterChildren(cells));
};

exports.countCells = countCells;

var countDivisions = function countDivisions(cells) {
  return (0, _reduceBreakpoints.reduceBreakpointsToObject)(function (breakpoint) {
    return _defineProperty({}, breakpoint, _react.Children.toArray(filterChildren(cells)).reduce(function (cellsSizes, _ref2) {
      var props = _ref2.props;
      return cellsSizes + countCellTotalSize(_objectSpread({}, props[breakpoint]));
    }, 0));
  });
};

exports.countDivisions = countDivisions;

var countCellsSizes = function countCellsSizes(cells) {
  return (0, _reduceBreakpoints.reduceBreakpointsToObject)(function (breakpoint) {
    return _defineProperty({}, breakpoint, _react.Children.map(filterChildren(cells), function (_ref4) {
      var props = _ref4.props;
      return countCellTotalSize(_objectSpread({}, props[breakpoint]));
    }));
  });
};

exports.countCellsSizes = countCellsSizes;

var countOffsets = function countOffsets(cells) {
  return (0, _reduceBreakpoints.reduceBreakpointsToObject)(function (breakpoint) {
    return _defineProperty({}, breakpoint, _react.Children.map(filterChildren(cells), function (_ref6) {
      var _props$breakpoint, _props$breakpoint$off;

      var props = _ref6.props;
      return ((_props$breakpoint = props[breakpoint]) === null || _props$breakpoint === void 0 ? void 0 : (_props$breakpoint$off = _props$breakpoint.offset) === null || _props$breakpoint$off === void 0 ? void 0 : _props$breakpoint$off.after) || 0;
    }));
  });
};

exports.countOffsets = countOffsets;

var mapCells = function mapCells(cells) {
  return _react.Children.map(filterChildren(cells), function (cell, index) {
    return (0, _react.cloneElement)(cell, {
      index: index
    });
  });
};

exports.mapCells = mapCells;